import { Injectable, inject } from '@angular/core';
import { AccountService } from '../../../../modules/account/account.service';
import { CommonService } from '../../../service/common/common.service';
import { DataService } from '../../../service/data/data.service';
import { Observable } from 'rxjs';
import { UserProfile } from '../enums/header-ai.model';

@Injectable({
  providedIn: 'root',
})
export class HeaderAiService {
  private accountService = inject(AccountService);
  private commonService = inject(CommonService);
  private dataService = inject(DataService);
  
  getProfile(): Observable<UserProfile> {
    return this.accountService.getProfile();
  }

  getMenuItems() {
    return this.commonService.getMenuItem();
  }

  refreshMenuItems(): void {
    this.commonService.refreshMenuItems();
  }

  isPlantAllowed() {
    return this.commonService.isPlantAllowed();
  }

  getUserPermissions(): string[] {
    return (this.commonService.getUserPermissions() || []) as string[];
  }

  canAccessModule(name: string) {
    return this.commonService.canAccessModule(name);
  }

  isAdmin() {
    return this.commonService.isAdmin();
  }

  setOrgUnits(units: any[]) {
    this.dataService.setOrgUnits(units);
  }
}
